export const ButtonLoader = () => {
    return (
        <div className="spinner-sec">
        <div
            className="spinner-loader"
        ></div>
        </div>
    );
}